module.exports = __webpack_public_path__ + "static/media/Advent03.a1f6c6d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Advent03.jpg
// module id = 372
// module chunks = 0